const host = `${window.location.protocol}//${window.location.host}/`
// const host = 'http://192.168.1.132:8888/'
const apiHost_ddns = 'http://share.ddns.yolanda.hk/'
// const apiHost = 'http://share.api.yolanda.hk/'
const api_test = 'http://sit.share.api.yolanda.hk/' // 测试服
// const apiHost = host.indexOf('192.168')>-1 ? apiHost_ddns: 'http://share.api.yolanda.hk/'
const apiHost = 'http://share.api.yolanda.hk/' // 正式服
// const apiHost_ddns = 'http://share.ddns.yolanda.hk/'
// const apiHost_ddns = 'http://share_sit.ddns.yolanda.hk/'
// 青少年报告iframe域名
// const iframeLink = 'http://xcx-h5-preview.glb.qnniu.com' // 测试服
const iframeLink = 'http://xcx-h5.yolanda.hk' // 正式服

module.exports = {
  host,
  apiHost,
  measure: apiHost + 'api/mobile/measurements',
  height_measure: apiHost + 'api/mobile/measurements/height_measure',
  updateInfo: apiHost + 'api/mobile/users/update',
  banner: apiHost + 'api/mobile/adverts',
  ranking: apiHost + 'api/mobile/users/ranking',
  sharePage: host + 'rank.html',
  editPage: host + 'EditPage.html',
  index_professional: host + 'index_professional.html',
  index_professional_perfect_scale: '', // 完美健康定制专业秤
  transfer_professional: host + 'transfer_professional.html',
  edit_professional: host + 'edit_professional.html',
  codeApi: 'https://mp.weixin.qq.com/cgi-bin/showqrcode?',
  professional: {
    measure: apiHost + 'api/mobile/measurements/measure',
    measureHistory: apiHost + 'api/mobile/measurements/professional_history'
  },
  height_weight: {
    send_code: apiHost + 'api/applet/measurements/send_code',
    login: apiHost + 'api/applet/measurements/height_login',
    measure: apiHost + 'api/applet/measurements/list_measurements'
  },
  get_history_dates: apiHost + 'api/mobile/measurements/get_history_dates',
  member: {
    member_info: apiHost + 'api/applet/apks/member_info', // 会员详情
    synchronize_member: apiHost + 'api/applet/apks/synchronize_member', // 同步会员资料
    create_member: apiHost + 'api/applet/apks/create_member' // 创建会员
  },
  iframeHost: iframeLink + '/professional_scale_teenager/index.html#/pages/teenagerReport/index', // 青少年H5地址
  teenager: {
    // 扫码获取专业秤儿童青少年测量报告
    // @see {http://yapi.runcobo.com/project/181/interface/api/5768}
    professional_younger_report: apiHost + '/api/mobile/measurements/professional_younger_report',

    /**
     * 获取儿童青少年报告详情
     * @see {http://yapi.runcobo.com/project/181/interface/api/5590}
     */
    show_younger_report: apiHost + '/api/mobile/measurements/show_younger_report'
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js